export function useLazyLoadQuery({ devicePermissionDialogResources, currentAppPermissionsDialogResources, currentAppDefaultPermissions, }) {
    return (query, _variables, _options) => {
        let results = { data: undefined };
        query.definitions.forEach((definition) => {
            if (definition.kind === 'OperationDefinition' && definition.name) {
                switch (definition.name.value) {
                    case 'DevicePermissionsRequestDialogQuery':
                        results = {
                            data: {
                                views: {
                                    devicePermissionsRequestDialogControl: {
                                        localizedStrings: devicePermissionDialogResources,
                                    },
                                },
                            },
                        };
                        break;
                    case 'DevicePermissionsCurrentAppPermissionsDialogWithSaveButtonQuery':
                        results = {
                            data: {
                                views: {
                                    devicePermissionsCurrentAppDialogWithSaveButtonControl: {
                                        localizedStrings: currentAppPermissionsDialogResources,
                                    },
                                },
                                m365PlatformApp: {
                                    devicePermissions: currentAppDefaultPermissions,
                                },
                            },
                        };
                        break;
                    default:
                        throw new Error(`AppHostNovaContextProvider encountered unknown query name: ${definition.name.value}`);
                }
            }
        });
        return results;
    };
}
//# sourceMappingURL=useLazyLoadQuery.js.map